module.exports = __webpack_public_path__ + "static/media/Industry-Medium.90ee2d5b.woff";